import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_PROPERTY_HISTORY_HANDLER = {
  topic: TOPIC_NAMES.OPEN_PROPERTY_HISTORY,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/PropertyHistory')
};